// extracted by mini-css-extract-plugin
module.exports = {"draft":"DraftIndicator_draft__cFBQ_","draft__tag":"DraftIndicator_draft__tag__Qrd5I"};